import { ParamComponent } from '../../Views/Question/Params';
export default ParamComponent;
